const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const resolveImg = (url) => {
    if (!url) return "";
    if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith("data:")) return url;
    return `${BACKEND_URL}${url}`;
};

const setMeta = (name, content, attr = "name") => {
    if (!content) return;
    let tag = document.head.querySelector(`meta[${attr}="${name}"]`);
    if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute(attr, name);
        document.head.appendChild(tag);
    }
    tag.setAttribute("content", content);
};

const setLink = (rel, href) => {
    if (!href) return;
    let tag = document.head.querySelector(`link[rel="${rel}"]`);
    if (!tag) {
        tag = document.createElement("link");
        tag.setAttribute("rel", rel);
        document.head.appendChild(tag);
    }
    tag.setAttribute("href", href);
};

export const applySEO = (seo = {}) => {
    if (seo.title) document.title = seo.title;
    setMeta("description", seo.description);
    setMeta("keywords", seo.keywords);

    // Open Graph
    setMeta("og:title", seo.title, "property");
    setMeta("og:description", seo.description, "property");
    setMeta("og:type", "website", "property");
    if (seo.site_url) setMeta("og:url", seo.site_url, "property");
    if (seo.og_image) setMeta("og:image", resolveImg(seo.og_image), "property");

    // Twitter
    setMeta("twitter:card", seo.og_image ? "summary_large_image" : "summary");
    setMeta("twitter:title", seo.title);
    setMeta("twitter:description", seo.description);
    if (seo.og_image) setMeta("twitter:image", resolveImg(seo.og_image));

    // Favicon
    if (seo.favicon) setLink("icon", resolveImg(seo.favicon));
};
